/**
 * Contract Renewal Reducers
 */
import {
  CONTRACT_RENEWAL_ACTION,
  CONTRACT_ALL_RENEWAL,
  CONTRACT_ADD_RENEWAL,
  CONTRACT_FETCH_RENEWAL,
  CONTRACT_EDIT_RENEWAL,
  CONTRACT_DELETE_RENEWAL,
} from 'Actions/types';

const INIT_STATE = {
  contractrenewallist: [],
  particularcontractrenewal: [],
  loading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CONTRACT_RENEWAL_ACTION:
      return { ...state, loading: true };

    case CONTRACT_ALL_RENEWAL:
      return { ...state, loading: false, contractrenewallist: action.payload };

    case CONTRACT_ADD_RENEWAL:
      return { ...state, loading: false };

    case CONTRACT_FETCH_RENEWAL:
      return { ...state, loading: false, particularcontractrenewal: action.payload };

    case CONTRACT_EDIT_RENEWAL:
      return { ...state, loading: false };

    case CONTRACT_DELETE_RENEWAL:
      return { ...state, loading: false };

    default:
      return state;
  }
};
